import React, { useState } from 'react';
import { Copy, Check, Terminal } from 'lucide-react';
import './Download.css';

const Download = () => {
  const [copiedIndex, setCopiedIndex] = useState(null);

  const steps = [
    { label: 'Clone Repository', command: 'git clone https://github.com/Shreeniwas1/stopspoti.git' },
    { label: 'Navigate to Folder', command: 'cd stopspoti' },
    { label: 'Install Dependencies', command: 'pip install psutil comtypes pycaw pywin32 customtkinter pystray Pillow' },
    { label: 'Run the Utility', command: 'python stopspotiv1.py' }
  ];

  const handleCopy = (text, index) => {
    navigator.clipboard.writeText(text);
    setCopiedIndex(index);
    setTimeout(() => setCopiedIndex(null), 2000);
  };

  return (
    <section id="installation" className="installation container">
      <div className="install-header">
        <h2>Setup Instructions</h2>
        <p>Get up and running in less than 30 seconds.</p>
      </div>

      <div className="terminal-window">
        <div className="terminal-header win-header">
          <div className="terminal-title win-title">
            <Terminal size={14} /> User: Windows PowerShell
          </div>
          <div className="terminal-buttons win-controls">
            <span className="term-win-min"></span>
            <span className="term-win-max"></span>
            <span className="term-win-close"></span>
          </div>
        </div>
        
        <div className="terminal-body">
          {steps.map((step, index) => (
            <div key={index} className="terminal-step">
              <span className="step-comment"># {step.label}</span>
              <div className="command-row">
                <span className="prompt">PS&gt;</span>
                <code className="command-text">{step.command}</code>
                <button 
                  className="copy-btn" 
                  onClick={() => handleCopy(step.command, index)}
                  aria-label="Copy to clipboard"
                >
                  {copiedIndex === index ? <Check size={16} className="text-green" /> : <Copy size={16} />}
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
      
    </section>
  );
};

export default Download;
